import React from "react";

export const Stats = ({ data }) => {
  if (!data) return null;
  return (
    <div id="stats">
      <div className="container">
        <div className="row text-center">
          {data.map((d, i) => (
            <div key={i} className="col-md-3 col-sm-6 stat-item">
              <div className="stat-value">{d.value}</div>
              <div className="stat-label">{d.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
